import React, { useEffect, useState } from "react";
import "./styles.scss";
import MdChevronLeft from "../../../constants/icons/Md/MdChevronLeft";
import MdChevronRight from "../../../constants/icons/Md/MdChevronRight";

const ActivityTabsHeader = ({
  tabsList = [],
  isMobileView = false,
  activeTab = "",
  onTabChange = () => {},
  isDisable = false,
}) => {
  const [startingIndex, setStartingIndex] = useState(0);

  useEffect(() => {
    if (isMobileView) {
      const findIndex = tabsList.findIndex((tab) => tab?.id === activeTab);
      if (findIndex !== tabsList?.length - 1) {
        setStartingIndex(findIndex);
      } else {
        setStartingIndex(findIndex - 1);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getTabs = () => {
    const first = tabsList[startingIndex];
    const second = tabsList[startingIndex + 1];
    return [first, second].map((tab, index) => {
      return (
        <div
          key={`${index} ${tab?.id}`}
          onClick={() => {
            if (isDisable) return;
            onTabChange(tab?.id);
          }}
          style={{
            height: "52px",
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            borderBottom: activeTab === tab?.id ? "1px solid #4403bf" : "",
          }}
        >
          <div
            className="mobileTabsStyles"
            style={{
              color: activeTab === tab?.id ? "white" : "#8C94A3",
            }}
          >
            {tab?.label}
          </div>
        </div>
      );
    });
  };
  if (isMobileView) {
    return (
      <div
        style={{
          backgroundColor: "#1D2026",
          height: "52px",
          padding: "0px 12px 0px 12px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div className="white-color">
          <MdChevronLeft
            onClick={() => {
              if (startingIndex - 1 >= 0) {
                setStartingIndex(startingIndex - 1);
              }
            }}
            color={startingIndex - 1 >= 0 ? "white" : "#8C94A3"}
            stroke={startingIndex - 1 >= 0 ? "white" : "#8C94A3"}
            fill={startingIndex - 1 >= 0 ? "white" : "#8C94A3"}
            size={20}
            style={{ cursor: "pointer" }}
          />
        </div>

        {getTabs()}
        <div className="white-color">
          <MdChevronRight
            onClick={() => {
              if (startingIndex + 2 < tabsList.length) {
                setStartingIndex(startingIndex + 1);
              }
            }}
            color={startingIndex + 2 < tabsList.length ? "white" : "#8C94A3"}
            stroke={startingIndex + 2 < tabsList.length ? "white" : "#8C94A3"}
            fill={startingIndex + 2 < tabsList.length ? "white" : "#8C94A3"}
            size={20}
            style={{ cursor: "pointer", color: "white" }}
          />
        </div>
      </div>
    );
  }
  return (
    <div
      className="tab-parent-div"
      style={{
        backgroundColor: "#1D2026",
        height: "52px",
        padding: "0px 15px 0px 15px",
        display: "flex",
      }}
    >
      {tabsList.map((tab, index) => {
        return (
          <div
            key={`${index} ${tab?.id}`}
            onClick={() => {
              if (isDisable) return;
              onTabChange(tab?.id);
            }}
            style={{
              height: "52px",
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
              borderBottom: activeTab === tab?.id ? "1px solid #4403bf" : "",
            }}
          >
            <div
              className="tabStyles"
              style={{
                color: activeTab === tab?.id ? "white" : "#8C94A3",
              }}
            >
              {tab?.label}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default React.memo(ActivityTabsHeader);
